module.exports = __webpack_public_path__ + "img/loadedCart.f1497cc0.png";